module.exports = __webpack_public_path__ + "img/BE0534752288.4b83b294.png";